import React, { PureComponent } from 'react'
import Button from 'aria-viewer/tour/components/buttons/button'
import Icon from 'aria-viewer/tour/components/icon'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import { properCase } from 'aria-viewer/utils/functions'
import Textfit from 'react-textfit'
import { MAIN_NAV_BUTTON_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'
import {
    FRONT_SINGLE,
    FRONT,
    RIGHT,
    LEFT,
    F,
    F_B,
    F_L,
    F_R,
    F_BL,
    F_BR,
    B,
    B_F,
    B_L,
    B_R,
    B_BL,
    B_BR,
    L,
    R,
} from 'aria-viewer/navigation/navigationActions'
import { SCREEN_SIZES, NAV_BUTTON_TYPES } from 'aria-viewer/tour/constants'
import Style from 'style-it'
import Browser from 'aria-viewer/utils/mobileDetect'

export const BUTTON_TYPES = {
    HINT: 'hint',
    ARROW: 'arrow',
    LOOK: 'look',
}

const S = {
    hintContainer: {
        position: 'relative',
        width: '100%',
        height: '100%',
    },
    hintTextfit: {
        maxHeight: '100%',
        width: '100%',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
    },
    titleTextfit: {
        maxHeight: '100%',
        width: '100%',
        marginTop: '0.1em',
    },
    hintDirectionImg: {
        width: '100%',
        height: '100%',
    },
    lookContainer: {
        position: 'absolute',
        width: '100%',
        height: '100%',
    },
    lookTitleContainer: {
        display: 'inline-block',
        width: '75%',
    },
    lookThumbImg: {
        width: '100%',
        height: '4.275em',
    },
    lookDirection: lookDirection => {
        return {
            textAlign: lookDirection,
            margin: '0.5em 0',
        }
    },
    lookArrowWrapper: lookDirection => {
        return {
            display: 'inline-block',
            width: '7%',
            height: '100%',
            float: lookDirection,
            position: 'relative',
        }
    },
    lookArrowIcon: ({ lookDirection, isRightArrow }) => {
        return {
            width: '1em',
            height: '1em',
            position: 'relative',
            top: '0.5em',
            transform: `rotate(${isRightArrow ? 270 : 90}deg)`,
            [lookDirection]: `${isRightArrow ? 0.5 : 0.4}em`,
        }
    },
}

//TODO | DIFFERENT COMPONENTS FOR EACH : Arrow/Look/Hint Buttons
//TODO | e.g. NavigationArrowButton, NavigationLookButton, NavigationHintButton

class NavigationButton extends PureComponent {
    static defaultProps = {
        singleHintButton: false,
    }

    handleOnClick = e => {
        const { onClick, actionName, trail, orientation, walkingDirection, mainMediaType } = this.props

        onClick && onClick(e, { actionName, trail, orientation, walkingDirection, mainMediaType })
    }
    getDirection = ({ type, direction }) => {
        switch (type) {
            case NAV_BUTTON_TYPES.ARROW:
            case NAV_BUTTON_TYPES.LOOK:
                return direction
            case NAV_BUTTON_TYPES.HINT:
                return Browser.phone() ? direction : FRONT
        }
    }
    getReadibleDirection = ({ direction }) => {
        switch (direction) {
            case F:
                return 'navigate to next point'
            case B:
                return 'navigate to previous point'
            case F_B:
            case B_F:
                return 'continue to next point'
            case F_L:
            case B_L:
            case L:
                return 'turn left to next point'
            case F_R:
            case B_R:
            case R:
                return 'turn right to next point'
            case F_BL:
            case B_BL:
                return 'bear left to next point'
            case F_BR:
            case B_BR:
                return 'bear right to next point'
                return 'continue to next point'
        }
    }
    buildButtonContent = () => {
        const { title, type, lookThumb } = this.props
        const { svg } = styleguide.navigation
        const direction = this.getDirection({ direction: this.props.direction, type })
        const readibleDir = this.getReadibleDirection({ direction: this.props.direction })

        switch (type) {
            case NAV_BUTTON_TYPES.ARROW:
                return (
                    <div
                        aria-live="polite"
                        aria-label={readibleDir}
                        role="button"
                        className="nav_arrows"
                        dangerouslySetInnerHTML={{ __html: svg.arrows[direction] }}
                    />
                )
            case NAV_BUTTON_TYPES.HINT:
                return (
                    <div style={S.hintContainer} role="button">
                        {direction != FRONT && <img src={svg.hints[direction]} style={S.hintDirectionImg} />}
                        <Icon icon={'arrowDown'} style={styleguide.navigation.hint_arrow[direction]} />
                        <label style={styleguide.navigation.hint_label[direction]}>
                            <Textfit style={S.hintTextfit} mode="multi" max={21} min={11}>
                                {title}
                            </Textfit>
                        </label>
                    </div>
                )
            case NAV_BUTTON_TYPES.LOOK:
                const lookDirection = direction.toLowerCase()
                return (
                    <div style={S.lookContainer}>
                        <div style={S.lookTitleContainer} role="button">
                            <div style={S.lookDirection(lookDirection)}>{`Look ${properCase(lookDirection)}`}</div>
                            <img src={lookThumb} style={S.lookThumbImg} />
                            <Textfit style={S.titleTextfit} mode="single" max={14} min={12}>
                                {title}
                            </Textfit>
                        </div>
                        <div
                            aria-label={`Look ${properCase(lookDirection)}`}
                            style={S.lookArrowWrapper(lookDirection)}
                            role="button"
                        >
                            <Icon
                                icon={'arrowDown'}
                                style={S.lookArrowIcon({
                                    lookDirection,
                                    isRightArrow: this.props.direction === RIGHT,
                                })}
                            />
                        </div>
                    </div>
                )
        }
    }

    getArrow = direction => {
        let arrowStyle = { width: '2em', height: '2.07em' }

        switch (direction) {
            case F:
                return Object.assign({}, arrowStyle, { top: '22%' })
            case L:
            case R:
                return Object.assign({}, arrowStyle, { width: '2.75em', top: '37%' })
            case F_L:
            case F_R:
                return Object.assign({}, arrowStyle, { width: '2.15em', top: '34%' })
            case F_B:
            case F_BL:
            case F_BR:
                return Object.assign({}, arrowStyle, { width: '2em', top: '26%' })
            default:
                return arrowStyle
        }
    }

    render() {
        const { style, type, singleHintButton, sizes } = this.props
        const direction = this.getDirection({ direction: this.props.direction, type })
        const largeScreen = sizes.width >= SCREEN_SIZES.size_1350

        //get smaller arrows if the screen is not large
        const screenArrow =
            !Browser.mobile() && !largeScreen && [NAV_BUTTON_TYPES.ARROW].includes(type) ? this.getArrow(direction) : {}

        return (
            <Button
                onClick={this.handleOnClick}
                tabIndex={MAIN_NAV_BUTTON_INDEX}
                alt="navigation"
                id={'navigation_' + direction}
                style={Object.assign(
                    {},
                    styleguide.navigation[type][singleHintButton ? FRONT_SINGLE : direction],
                    { cursor: 'pointer' },
                    style,
                    screenArrow
                )}
            >
                <Style>
                    {` 
					.nav_arrows svg {
						position: absolute;
					}
				`}
                </Style>
                {this.buildButtonContent()}
            </Button>
        )
    }
}

export default NavigationButton
